export class NewPasswordUser {
  name: string;
  existingPassword: string;
  password: string;
}
